if (!customElements.get('collapsible-text')) {
  class CollapsibleText extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      if (!event.target.closest('[js-ct-toggle]')) return;

      event.preventDefault();
      this.classList.toggle('is-open');
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('collapsible-text', CollapsibleText);
}
